import React from "react";
import { ChannelInfoWrapper } from "../ChannelInfoWrapper";
import { AuditlogList } from "components/AuditlogList/AuditlogList";

const ChannelAuditTrail = ({
  entityId,
  objectId,
}: {
  entityId: string;
  objectId: string;
}) => {
  return (
    <ChannelInfoWrapper
      title={
        <div className="t-text-subtext t-flex t-gap-1 t-items-center">
          Activity
        </div>
      }
      hasDetails={false}
    >
      <AuditlogList
        entityId={entityId}
        objectId={objectId}
        contentClass="!t-p-0"
      />
    </ChannelInfoWrapper>
  );
};

export default ChannelAuditTrail;
